import ApiHttpHandler from "./apiHttpHandler";
import { IWarehouse } from "../interfaces/Warehouse";

const handler = new ApiHttpHandler();

const getWarehouses = (location?: string): Promise<IWarehouse[]> => {
    return handler.get(`warehouses`)
};

export default { getWarehouses }